import { render, staticRenderFns } from "./FormBaseAnsesPersonasFisicas.vue?vue&type=template&id=1d5205e6"
import script from "./FormBaseAnsesPersonasFisicas.vue?vue&type=script&lang=js"
export * from "./FormBaseAnsesPersonasFisicas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports